
import WidgetDefaultNuxt from '../default/nuxt.vue';
import defaultValues from '@xd-rocket/attributes/src/attributes/progress/default';

export default {
  name: 'WidgetProgressNuxt',
  extends: WidgetDefaultNuxt,
  data: function () {
    const { values, getLocaleValue } = this;
    let progress = values.progress || defaultValues.progress;
    let total = this.filterTotal(getLocaleValue(progress.total));
    return {
      widgetClassName: 'widget-progress',
      customClass: {
        ['widget-progress-' + progress.type]: true,
        'with-keep': progress.keep,
        'with-clip': progress.clip,
        ['with-' + (progress.vertical ? 'vertical' : 'horizontal')]:
          progress.type === 'line',
      },
      progress,
      total,
      originValue: getLocaleValue(progress.value),
      steps: this.filterSteps(getLocaleValue(progress.steps), total),
      status: progress.status,
      localePath: [
        {
          key: 'total',
          value: progress.total,
          update: this.filterTotal,
        },
        {
          key: 'originValue',
          value: progress.value,
        },
        {
          key: 'steps',
          value: progress.steps,
          update: this.filterSteps,
        },
      ],
    };
  },
  computed: {
    count() {
      if (this.status > 0) return this.total;
      return Math.max(Math.min(this.originValue, this.total), 0);
    },
    percent() {
      let { total, count } = this;
      if (count >= total) return 100;
      return Math.floor((count / total) * 10000) / 100;
    },
    hasStep() {
      return (
        this.steps.length > 0 && !(this.progress.hideSteps && this.status !== 0)
      );
    },
    currentStep() {
      const { steps, count, hasStep } = this;
      if (!hasStep) return 0;
      return steps.findIndex((o) => o.value >= count);
    },
    barStyleVars() {
      let result = this.percent + '%';
      if (this.hasStep && this.percent) {
        const { steps, currentStep, count } = this;
        let v;
        let step = steps[currentStep];
        let lastValue = 0;
        let lastView = 0;
        if (currentStep) {
          lastValue = steps[currentStep - 1]?.value;
          lastView = steps[currentStep - 1]?.view;
        }
        v =
          ((count - lastValue) / (step.value - lastValue)) * step.weight * 100 +
          lastView;
        v = Math.round(v * 100) / 100;
        result = v + '%';
        result = `${result} - var(--rocket-progress--margin-right, 0px) * ${
          ((steps.length - 1) * this.percent - currentStep * 100) / 100
        }`;

        result = `calc(${result})`;
      }
      return {
        '--rocket-progress-percent': result,
      };
    },
  },
  watch: {
    count(v) {
      if (v >= this.total) {
        this.handleUpdateStatus(1);
      } else {
        this.handleUpdateStatus(0);
      }

      this.rocketEmit(
        'rocket:progress:after-change',
        true,
        this.count,
        this.percent,
        this.currentStep,
        this.status
      );
    },
    currentStep() {
      this.rocketEmit(
        'rocket:progress:after-change-step',
        true,
        this.count,
        this.percent,
        this.currentStep,
        this.status
      );
    },
  },
  methods: {
    initEvent() {
      // 更新进度
      this.rocketOn('rocket:progress:set', true, this.handleSetValue);
      // 获取进度
      this.rocketOn('rocket:progress:get', true, (cb) => {
        if (cb) {
          let v = this.percent;
          cb(this.count, v, this.currentStep, this.status);
        }
      });
      // 修改状态
      this.rocketOn('rocket:progress:set-status', true, (v) => {
        v = v * 1;
        this.handleUpdateStatus(v);
      });
    },
    filterTotal(v) {
      v = Math.max(v, 0) || 100;
      if (this.total !== undefined && v !== this.total) {
        // 更新 total 时检查是否需要更新 steps
        this.steps = this.filterSteps(this.steps, v);
      }
      return v;
    },
    filterSteps(steps, total) {
      if (!total) total = this.total;
      let result = [];
      if (!steps?.length || !total) {
        return result;
      }
      let len = steps.length;
      let lastTotal = 0;
      let lastIndex = -1;
      let lastView = 0;
      let arrTotal = [];
      let arrView = [];
      for (let i = 0; i < len; i++) {
        let o = { ...steps[i] };
        arrTotal.push(o.value);
        arrView.push(o.view);
        result.push(o);
      }
      let end = result.slice(-1)[0];
      if (end.value < total) {
        arrTotal.push(total);
        arrView.push(100);
        if (end) {
          result.push({
            ...end,
            value: total,
            view: 100,
          });
        }
        len = result.length;
      } else {
        end.view = 100;
      }
      // 计算子阶段目标值
      for (let i = 0; i < len; i++) {
        let t = arrTotal[i];
        if (len - i === 1) {
          t = total;
        } else {
          if (t >= total || t < lastTotal) t = 0; // 检查阶段目标不能小于之前的
        }
        if (t > 0) {
          // 中间需要差值
          if (i - lastIndex > 1) {
            let diff = (t - lastTotal) / (i - lastIndex);
            for (let j = lastIndex + 1; j < i; j++) {
              let v =
                Math.round(((j - lastIndex) * diff + lastTotal) * 100) / 100;
              arrTotal[j] = v;
              result[j].value = arrTotal[j];
            }
          }
          lastTotal = t;
          lastIndex = i;
          arrTotal[i] = t;
          result[i].value = t;
        }
      }
      // 计算子阶段展示占比
      lastTotal = 0;
      lastIndex = -1;
      for (let i = 0; i < len; i++) {
        let w = arrView[i];
        let t = arrTotal[i];
        if (len - i === 1) {
          w = 100;
        } else {
          if (w >= 100 || w < lastView) w = 0;
        }

        if (w > 0) {
          // 中间需要差值
          if (i - lastIndex > 1) {
            let sumTotal = t - lastTotal; // 比重为0的阶段目标区间值
            let diff = w - lastView;
            for (let j = lastIndex + 1; j < i; j++) {
              let ratio = (arrTotal[j] - lastTotal) / sumTotal;
              let weight = ratio * diff;
              arrView[j] = weight + lastView;
              result[j].view = arrView[j];
              result[j].weight = weight / 100;

              lastView = arrView[j];
              lastTotal = arrTotal[j];
            }
          }
          result[i].weight = (w - lastView) / 100;
          lastView = w;
          lastIndex = i;
          lastTotal = t;
        }
      }
      return result;
    },
    handleSetValue(v) {
      this.originValue = v;
      // 解除与数据池的关联
      if (this.localePath.length) {
        if (this.localePath.find((o) => o.key === 'originValue')) {
          this.localePath = this.localePath.filter(
            (o) => o.key !== 'originValue'
          );
          this.updateLocalePathMap();
        }
      }
    },
    handleUpdateStatus(v) {
      if (this.status === v) return;
      this.status = v;
      this.rocketEmit(
        'rocket:progress:after-change-status',
        true,
        this.count,
        this.percent,
        this.currentStep,
        this.status
      );
      if (v > 0) {
        this.rocketEmit('rocket:progress:success', true);
      } else if (v < 0) {
        this.rocketEmit(
          'rocket:progress:error',
          true,
          this.count,
          this.percent,
          this.currentStep
        );
      }
    },
  },
};
